import { render, staticRenderFns } from "./Ambassadors.vue?vue&type=template&id=4f33db15&scoped=true"
import script from "./Ambassadors.vue?vue&type=script&lang=js"
export * from "./Ambassadors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f33db15",
  null
  
)

export default component.exports